import { render, staticRenderFns } from "./ver_pagos.vue?vue&type=template&id=4f18a741"
import script from "./ver_pagos.vue?vue&type=script&lang=js"
export * from "./ver_pagos.vue?vue&type=script&lang=js"
import style0 from "./ver_pagos.vue?vue&type=style&index=0&id=4f18a741&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports